const styles = {
    info: {
      type: 'info',
      backgroundColor: '#ECF4F9',
      icon: require('../../common/assets/img/info-icon.png'),
      linkColor: '#31769B'
    },
    warning: {
      type: 'warning',
      backgroundColor: '#FFFBE7',
      icon: require('../../common/assets/img/warning-icon.png') ,
      linkColor: '#E5A600' 
    },
    success: {
      type: 'success',
      backgroundColor: '#EBFBE6',
      icon: require('../../common/assets/img/success-icon.png') ,
      linkColor: '#237B4B'       
    },  
    error: {
      type: 'error',
      backgroundColor: '#FFE7EC',
      icon: require('../../common/assets/img/error-icon.png'),
      linkColor: '#B00020'      
    }
  };

  export default styles;